import { ref } from 'vue'

export const idTimeout = ref()
